import React, { useState } from "react";
import { Jumbotron, Container, Row, Col, Tab, Nav } from "react-bootstrap";
import "./styles.css";

function Skill({ name, logoUrl }) {
  return (
    <div className="skill">
      <img src={logoUrl} alt={name} />
    </div>
  );
}

function chunkArray(array, chunkSize) {
  const chunks = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize));
  }
  return chunks;
}

function Skills({ skills }) {
  const [activeTab, setActiveTab] = useState("LANGUAGES");

  const numColumns = 4;
  
  const skillCategories = Object.entries(skills).map(
    ([category, categorySkills]) => ({
      category,
      categorySkills: chunkArray(categorySkills, numColumns),
    })
  );

  return (
    <Jumbotron
      fluid
      className="m-0"
      id="skills"
      style={{ backgroundColor: "#f8f9fa" }}
    >
      <Container>
        <h2 className="display-4 pb-6 text-center">Skills</h2>
        <Tab.Container activeKey={activeTab}>
          <Row className="pt-3">
            <Col md={12}>
              <Nav variant="tabs" className="justify-content-center">
                {skillCategories.map(({ category }, index) => (
                  <Nav.Item key={index}>
                    <Nav.Link
                      eventKey={category}
                      onClick={() => setActiveTab(category)}
                    >
                      {category}
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            </Col>
            <Col md={12}>
              <Tab.Content>
                {skillCategories.map(({ category, categorySkills }, index) => (
                  <Tab.Pane key={index} eventKey={category}>
                    <Row className={`pt-5 row-skills`}>
                      {categorySkills.map((chunk, subIndex) => (
                        <Col key={subIndex}>
                          {chunk.map((skill, skillIndex) => (
                            <Skill
                              key={skillIndex}
                              name={Object.keys(skill)[0]}
                              logoUrl={Object.values(skill)[0]}
                            />
                          ))}
                        </Col>
                      ))}
                    </Row>
                  </Tab.Pane>
                ))}
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </Container>
    </Jumbotron>
  );
}

export default Skills;
